 import React from 'react';
import { IColumn, IDetailsColumnProps } from '@fluentui/react';
import {CommandActions as FiltersCommandActions} from '../../redux/actions/filters';
import _ from 'lodash';
import { DirectionalHint, FontIcon, FontSizes, Icon, IconButton, IContextualMenuListProps, IContextualMenuProps, Link, Selection, Text, TooltipHost } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { Project } from '../../models/project';
import {CommandActions as ProjectCommandActions} from '../../redux/actions/project';

export const getColumns = ( openOrCloseProjectModal: typeof ProjectCommandActions.openOrCloseProjectModal) => {
      const styles = getClassNames(false);


      const colums: IColumn[] = [
          
        {
          key: 'projectId',
          name: 'Code',
          fieldName: 'projectId',
          minWidth: 90,
          maxWidth: 90,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,
          onRender: (item: Project) => {
            return (
              <Link onClick={() => {
                openOrCloseProjectModal({open: true, projectId: item.projectId})
              }}>{item.projectId}</Link>   
            );                  
          }
           
        },
        {
          key: 'projectName',
          name: 'Name',
          fieldName: 'projectName',
          minWidth: 200,
          maxWidth: 200,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
        },
        {
          key: 'isEnabled',
          name: 'Enabled',
          fieldName: 'isEnabled',
          minWidth: 90,
          maxWidth: 90,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
          onRender: (item: Project) => {
              return (
                <div> {item.isEnabled ? 'Yes' : 'No'}</div>
              );                  
          }
        },
        {
          key: 'isActivatedInAgile',
          name: 'Activated in Agile',
          fieldName: 'isActivatedInAgile',
          minWidth: 140,
          maxWidth: 140,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
          onRender: (item: Project) => {
            return (
              <div> {item.isActivatedInAgile ? 'Yes' : 'No'}</div>
            );                  
          }
        },
        {
          key: 'template',
          name: 'Template',
          fieldName: 'template',
          minWidth: 90,
          maxWidth: 90,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
        },
        {
          key: 'isApproveWithCommentsStatusActive',
          name: 'Approve with comments',
          fieldName: 'isApproveWithCommentsStatusActive',
          minWidth: 160,
          maxWidth: 160,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
          onRender: (item: Project) => {
            return (
              <div> {item.isApproveWithCommentsStatusActive ? 'Yes' : 'No'}</div>
            );                  
          }
        },
        {
          key: 'isInternalCheckActive',
          name: 'Internal Check',
          fieldName: 'isInternalCheckActive',
          minWidth: 110,
          maxWidth: 110,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
          onRender: (item: Project) => {
            return (
              <div> {item.isInternalCheckActive ? 'Yes' : 'No'}</div>
            );                  
          }
        },
        {
          key: 'isExternalCheckActive',
          name: 'External Check',
          fieldName: 'isExternalCheckActive',
          minWidth: 110,
          maxWidth: 110,
          isResizable: true,
          //onColumnClick: (handleClick) ? handleClick : () => {},
          data: 'string',
          isPadded: false,   
          onRender: (item: Project) => {
            return (
              <div> {item.isExternalCheckActive ? 'Yes' : 'No'}</div>
            );                  
          }
        },
      
        
    ];
    return colums;
}